import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import ReCAPTCHA from 'react-google-recaptcha'

import config from '../config/config'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import DisplayMessage from '../components/DisplayMessage'
import { setFlashMessage } from '../contexts/WebsiteContext'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const Contact = () => {
  const { t } = useTranslation()
  const pageName = 'CONTACT'

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [captchaToken, setCaptchaToken] = useState('')
  const [isMessageError, setIsMessageError] = useState(false)
  const [isNameError, setIsNameError] = useState(false)
  const [isEmailError, setIsEmailError] = useState(false)
  const [isCaptchaError, setIsCaptchaError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSendContact = async (e) => {
    e.preventDefault()
    window.scrollTo(0, 0)

    if (!captchaToken) {
      setIsCaptchaError(true)
      return
    }
    setIsCaptchaError(false)

    const isMessageInvalid = !message || message.length < 20
    setIsMessageError(isMessageInvalid)
    setIsNameError(!name)
    setIsEmailError(!email)

    if (isMessageInvalid || !name || !email) {
      return
    }

    setIsSubmitting(true)

    try {
      const response = await fetch(`${config.apiUrl}contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      })

      if (response.ok) {
        setFlashMessage(t('MESSAGE_SENT'), 'success')
        setName('')
        setEmail('')
        setMessage('')
        setCaptchaToken('')
      } else {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token)
  }

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('TO_CONTACT_ME')} description="" />

      <div
        className="block-wrapper mt-4"
        style={{ maxWidth: '600px', margin: 'auto' }}
      >
        <Form onSubmit={handleSendContact}>
          <Form.Group controlId="formBasicName">
            <Form.Label>{t('LASTNAME')}</Form.Label>
            {isNameError && (
              <DisplayMessage
                messageType="error"
                message={t('REGISTER_ERROR_LASTNAME')}
              />
            )}
            <Form.Control
              type="text"
              placeholder={t('LASTNAME_PLACEHOLDER')}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>

          <Form.Group
            controlId="formBasicEmail"
            style={{ margin: '20px 0 0 0' }}
          >
            <Form.Label>{t('EMAIL_ADDRESS')}</Form.Label>
            {isEmailError && (
              <DisplayMessage
                messageType="error"
                message={t('REGISTER_ERROR_EMAIL_ADDRESS')}
              />
            )}
            <Form.Control
              type="email"
              placeholder={t('EMAIL_ADDRESS_PLACEHOLDER')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>

          <Form.Group
            controlId="formBasicMessage"
            style={{ margin: '20px 0 0 0' }}
          >
            <Form.Label>{t('MESSAGE')}</Form.Label>
            {isMessageError && (
              <DisplayMessage
                messageType="error"
                message={t('CONTACT_ERROR_MESSAGE')}
              />
            )}
            <Form.Control
              as="textarea"
              rows={5}
              placeholder={t('MESSAGE_PLACEHOLDER')}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Form.Group>

          <div className="text-center m-3" style={{ paddingBottom: '40px' }}>
            <div style={{ margin: '20px auto', width: '300px' }}>
              {isCaptchaError && (
                <DisplayMessage
                  messageType="error"
                  message={t('CAPTCHA_ERROR')}
                />
              )}
              <ReCAPTCHA
                sitekey={config.recaptchaKey}
                onChange={handleCaptchaChange}
              />
            </div>

            <Button variant="primary" type="submit" disabled={isSubmitting}>
              {isSubmitting ? t('SEND_IN_PROGRESS') : t('SEND')}
            </Button>
          </div>
        </Form>
      </div>

      <div className="container">
        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default Contact
